<template>
    <div class="p-2">
        <div class="grid grid-cols-10 gap-0.5">
            <div
                v-for="cell in 100"
                :key="cell"
                class="w-4 h-4 border cursor-pointer transition-colors duration-75"
                :class="
                    isCellHighlighted(cell)
                        ? 'bg-blue-500 border-blue-400 dark:bg-blue-600 dark:border-blue-500'
                        : 'bg-neutral-100 border-neutral-300 dark:bg-neutral-800 dark:border-neutral-600'
                "
                @mouseenter="onCellHover(cell)"
                @click="onCellClick"
            ></div>
        </div>
        <div class="mt-1.5 text-center text-xs text-neutral-500 dark:text-neutral-400">
            <template v-if="hoverCols > 0">{{ hoverCols }} &times; {{ hoverRows }}</template>
            <template v-else>&nbsp;</template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
    editor: any;
}>();

const emit = defineEmits<{
    (event: 'close'): void;
}>();

const hoverRows = ref(0);
const hoverCols = ref(0);

const onCellHover = (cell: number) => {
    hoverRows.value = Math.ceil(cell / 10);
    hoverCols.value = ((cell - 1) % 10) + 1;
};

const isCellHighlighted = (cell: number): boolean => {
    const row = Math.ceil(cell / 10);
    const col = ((cell - 1) % 10) + 1;
    return row <= hoverRows.value && col <= hoverCols.value;
};

const onCellClick = () => {
    if (hoverCols.value > 0 && hoverRows.value > 0) {
        props.editor
            .chain()
            .focus()
            .insertTable({ rows: hoverRows.value, cols: hoverCols.value, withHeaderRow: true })
            .run();
        emit('close');
    }
};
</script>
